import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["matchKindSelect", "singleContainer", "multiContainer", "singleInput", "multiInput", "syncedValue"]

  connect() {
    this.updateContainers()
    this.restoreFromHidden()
  }

  matchKindChanged() {
    this.updateContainers()
    if (this.hasSyncedValueTarget) this.syncedValueTarget.value = ""
    if (this.hasSingleInputTarget) this.singleInputTarget.value = ""
    if (this.hasMultiInputTarget) {
      Array.from(this.multiInputTarget.options).forEach(o => o.selected = false)
    }
  }

  syncFromSingle() {
    if (this.hasSyncedValueTarget && this.hasSingleInputTarget) {
      this.syncedValueTarget.value = this.singleInputTarget.value
    }
  }

  syncFromMulti() {
    if (this.hasSyncedValueTarget && this.hasMultiInputTarget) {
      const selected = Array.from(this.multiInputTarget.selectedOptions).map(o => o.value)
      this.syncedValueTarget.value = selected.join(",")
    }
  }

  updateContainers() {
    if (!this.hasMatchKindSelectTarget) return
    const isMulti = ["in", "not_in"].includes(this.matchKindSelectTarget.value)
    if (this.hasSingleContainerTarget) this.singleContainerTarget.hidden = isMulti
    if (this.hasMultiContainerTarget) this.multiContainerTarget.hidden = !isMulti
  }

  restoreFromHidden() {
    if (!this.hasSyncedValueTarget) return
    const stored = this.syncedValueTarget.value
    if (!stored) return

    const isMulti = this.hasMatchKindSelectTarget && ["in", "not_in"].includes(this.matchKindSelectTarget.value)

    if (isMulti && this.hasMultiInputTarget) {
      const values = stored.split(",")
      Array.from(this.multiInputTarget.options).forEach(o => {
        o.selected = values.includes(o.value)
      })
    } else if (this.hasSingleInputTarget) {
      this.singleInputTarget.value = stored
    }
  }
}
